// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__1lY50","image-wrapper":"styles-m__image-wrapper__Am2Y8","text-wrapper":"styles-m__text-wrapper__1riyg","headline":"styles-m__headline__3fd1b"};